import {useTranslation} from "react-i18next";
import "./Platform.css"
import useAnimation from "../../utils/hooks/animate";
import {useEffect} from "react";

export const Platform = () => {
    const {i18n, t} = useTranslation();
    const isRutube: boolean = i18n.language === "ru";
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("platform")});
    }, [t]);

    return (
        <main className="pt-2">
            <section>
                <p className="text-center animated">{t('platform.1.1')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('platform.2.1')}</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('platform.2.2.1')}</strong> {t('platform.2.2.2')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('platform.2.2.3')}</strong> {t('platform.2.2.4')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('platform.2.2.5')}</strong> {t('platform.2.2.6')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('platform.2.2.7')}</strong> {t('platform.2.2.8')}</p></li>
                </ul>
            </section>
            <section>
                <p className="text-center header-main animated">{t('platform.3.1')}</p>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                        <thead>
                        <tr>
                            <th>{t('platform.3.2')}</th>
                            <th className="table-success">{t('platform.3.3')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{t('platform.3.2.1')}</td>
                            <td className="table-success">{t('platform.3.3.1')}</td>
                        </tr>
                        <tr>
                            <td>{t('platform.3.2.2')}</td>
                            <td className="table-success">{t('platform.3.3.2')}</td>
                        </tr>
                        <tr>
                            <td>{t('platform.3.2.3')}</td>
                            <td className="table-success">{t('platform.3.3.3')}</td>
                        </tr>
                        <tr>
                            <td>{t('platform.3.2.4')}</td>
                            <td className="table-success">{t('platform.3.3.4')}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <section>
                <p className="text-center animated">{t('platform.1.2')}</p>
                {[
                    [isRutube ? "87697113145f65ae119230cf4d03d374" : "uhAnq-gm5cQ", t('platform.link.1')],
                    [isRutube ? "4644a267fc243cb8e5a9ab1b060923b6" : "hN-Tm3xIaqI", t('platform.link.2')],
                    [isRutube ? "d9a24863d02b5f5a9c04fc853ac70f20" : "S69-mh2bNw8", t('platform.link.3')],
                ].map(([src, text], i) => (
                    <div key={i} className="row">
                        <div className="col-7 text-end">{text}</div>
                        <div className="col-1">
                            <a target="_blank" rel="noreferrer" href={isRutube ? `https://rutube.ru/video/${src}` : `https://www.youtube.com/watch?v=${src}`}>{t('link')}</a>
                        </div>
                    </div>
                ))}
            </section>
            <section>
                <p className="text-center animated">{t('platform.p.2')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('platform.p.3')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('platform.p.4')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('platform.p.5')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('platform.p.6')}</p>
            </section>
        </main>
    );
};